import { render, staticRenderFns } from "./ConfirmDialogBox.vue?vue&type=template&id=72afed3a&scoped=true"
import script from "./ConfirmDialogBox.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogBox.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialogBox.vue?vue&type=style&index=0&id=72afed3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afed3a",
  null
  
)

export default component.exports